import CyrillicToTranslit from 'cyrillic-to-translit-js';

export const cyrillicToTranslitRu = new (CyrillicToTranslit as any)({preset: 'ru'});

export const transliterateRuToUpperCase = (text: string, separator = '_') => {
  return cyrillicToTranslitRu.transform(text, separator).toUpperCase();
};
